/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {
  MdCommonModule,
  MdLineModule,
  MdPseudoCheckboxModule,
  MdRippleModule,
} from '@angular/material/core';
import {
  MdDividerCssMatStyler,
  MdList,
  MdListAvatarCssMatStyler,
  MdListCssMatStyler,
  MdListDivider,
  MdListIconCssMatStyler,
  MdListItem,
  MdListSubheaderCssMatStyler,
  MdNavListCssMatStyler,
} from './list';
import {MdListOption, MdSelectionList} from './selection-list';
export class MdListModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [MdLineModule, MdRippleModule, MdCommonModule, MdPseudoCheckboxModule, CommonModule],
  exports: [
    MdList,
    MdListItem,
    MdListDivider,
    MdListAvatarCssMatStyler,
    MdLineModule,
    MdCommonModule,
    MdListIconCssMatStyler,
    MdListCssMatStyler,
    MdNavListCssMatStyler,
    MdDividerCssMatStyler,
    MdListSubheaderCssMatStyler,
    MdPseudoCheckboxModule,
    MdSelectionList,
    MdListOption
  ],
  declarations: [
    MdList,
    MdListItem,
    MdListDivider,
    MdListAvatarCssMatStyler,
    MdListIconCssMatStyler,
    MdListCssMatStyler,
    MdNavListCssMatStyler,
    MdDividerCssMatStyler,
    MdListSubheaderCssMatStyler,
    MdSelectionList,
    MdListOption
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdListModule_tsickle_Closure_declarations() {
/** @type {?} */
MdListModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdListModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
